<template>
  <div v-if="item">
    <v-dialog v-model="modal_edit" persistent max-width="760px" scrollable>
      <v-card class="dialog-card">
        <!-- Header -->
        <div class="dialog-header">
          <div class="d-flex align-center">
            <div class="dialog-header-icon">
              <v-icon color="white" size="28">
                mdi-clipboard-edit-outline
              </v-icon>
            </div>

            <div class="ml-4">
              <div class="dialog-eyebrow">MANAJEMEN JABATAN</div>

              <div class="dialog-title">Edit Perangkat / Alat Kerja Jabatan</div>

              <div class="dialog-subtitle">
                Perbarui informasi dan rincian perangkat / alat kerja jabatan.
              </div>
            </div>
          </div>

          <v-btn icon dark class="dialog-close" @click="close_modal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-divider></v-divider>

        <!-- FORM -->
        <v-card-text class="dialog-content">
          <v-form ref="form" lazy-validation>
            <div class="dialog-section">
              <div class="dialog-section-heading">
                <div class="dialog-section-icon">
                  <v-icon size="20"> mdi-text-box-outline </v-icon>
                </div>

                <div>
                  <div class="dialog-section-title">Perangkat / Alat Kerja</div>

                  <div class="dialog-section-description">
                    Tuliskan perangkat / alat kerja jabatan.
                  </div>
                </div>
              </div>

              <div class="dialog-field">
                <label class="dialog-label">
                  Nama Perangkat / Alat Kerja
                  <span class="dialog-required">*</span>
                </label>

                <v-textarea
                  v-model="item.nama"
                  outlined
                  dense
                  rows="3"
                  auto-grow
                  hide-details="auto"
                  class="dialog-input"
                ></v-textarea>
              </div>

              <div class="dialog-field">
                <label class="dialog-label">
                  Penggunaan
                  <span class="dialog-required">*</span>
                </label>

                <v-textarea
                  v-model="item.penggunaan"
                  outlined
                  dense
                  rows="3"
                  auto-grow
                  hide-details="auto"
                  class="dialog-input"
                ></v-textarea>
              </div>
            </div>
          </v-form>
        </v-card-text>

        <v-divider />

        <!-- FOOTER -->
        <v-card-actions class="dialog-footer">
          <div class="dialog-footer-note">
            <v-icon size="17" color="grey"> mdi-information-outline </v-icon>

            <span> Pastikan seluruh data sudah benar. </span>
          </div>

          <v-spacer />

          <v-btn
            depressed
            outlined
            color="grey darken-1"
            class="text-none dialog-cancel-btn"
            :disabled="loading"
            @click="close_modal"
          >
            Batal
          </v-btn>

          <v-btn
            depressed
            color="primary"
            class="text-none dialog-submit-btn"
            :loading="loading"
            :disabled="loading"
            @click="edit()"
          >
            <v-icon left size="18"> mdi-content-save-outline </v-icon>

            Simpan Data
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import cookie from "@/helper/cookie.js";
import SData from "@/store/anjab/infojabatan/perkerjab";

import "@/assets/styles/pages/anjab/infojabatan/perkerjab/edit.css";

export default {
  data: () => ({
    token: "",
    session: "",
    lbtn: false,
    loading: false,
  }),

  computed: {
    modal_edit: {
      get() {
        return SData.state.modal_edit;
      },

      set(value) {
        SData.commit("open_edit", value);
      },
    },

    item() {
      return SData.state.data;
    },
  },

  watch: {
    async modal_edit(value) {
      if (value) {
        this.token = await cookie.get("token");
      }
    },
  },

  methods: {
    async edit() {
      if (!this.$refs.form.validate()) return;

      const item = this.item || {};
      const id = item.ID_INFO || item.id;

      if (!id) {
        SData.commit("alert_text", "ID uraian tugas tidak ditemukan");
        SData.commit("alert_g", true);
        SData.commit("alert_b", false);
        return;
      }

      this.loading = false;

      const data = {
        pk_id: this.item.id,
        pk_nama: this.item.nama,
        pk_penggunaan: this.item.penggunaan,
      };

      const url = `${process.env.VUE_APP_API}/perkerjab/edit`;

      try {
        const res = await this.axios.put(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        });

        if (res.data && res.data.success) {
          SData.commit("refresh", true);
          SData.commit("alert_text", "Berhasil Memperbarui Data");
          SData.commit("alert_b", true);
          SData.commit("alert_g", false);

          this.close_modal();
        } else {
          SData.commit("alert_text", "Gagal Memperbarui Data");
          SData.commit("alert_g", true);
          SData.commit("alert_b", false);
        }
      } catch (error) {
        SData.commit("alert_text", "Gagal Memperbarui Data");
        SData.commit("alert_g", true);
        SData.commit("alert_b", false);

        console.error(
          "Error edit uraian tugas:",
          error.response || error.message,
        );
      } finally {
        this.loading = false;
      }
    },

    close_modal() {
      SData.commit("close_edit", false);
    },
  },
};
</script>
